module.exports = "/_next/static/images/a33d7ba8e1192f49d0f29cd93ae7433a-instalments-change.gif";